<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 60 90 60">
  <path d="M78.696 77.776c-.096-3.051-.936-5.86-2.596-8.259-7.175-10.358-26.935-9.095-44.136 2.819-17.202 11.914-25.165 30.02-17.991 40.377 7.141 10.312 26.878 9.057 44.028-2.711.088-.09.025-.176-.083-.121-9.523 5.475-17.835 5.49-21.552.004-3.753-5.535.197-14.799 8.248-20.181 2.983-1.994 6.274-3.428 9.143-3.985l-1.078 5.458c-.049.225.014.451.186.569.178.122.419.106.627-.017l16.593-9.109a.83.83 0 0 0 .4-.548c.048-.236-.033-.44-.192-.549l-12.98-8.962c-.158-.104-.429-.166-.642-.049a.818.818 0 0 0-.403.555l-.818 4.072c-5.134.354-10.483 2.356-15.458 5.729-11.112 7.53-16.056 19.659-11.031 27.075 1.332 1.965 3.233 3.404 5.512 4.314.344.139.344.129.344.129l-.008.068c-4.105-.629-7.342-2.781-9.362-5.697-6.2-8.949.307-24.25 14.387-34 14.079-9.753 30.444-10.404 36.645-1.452.95 1.373 1.642 2.823 2.02 4.44.008.039.015.076.025.115.024.106.172.09.172-.084z"/>
</svg>
</template>

<script>
export default {
  name: 'UwvLogo'
};
</script>
